<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex>
        <v-card>
          <v-card-title primary-title class="primary white--text headline">
            Topic Form
          </v-card-title>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex>
                  <form>
                    <v-layout row>
                      <v-flex xs6>
                        <v-text-field
                        disabled
                        v-model="item.id"
                        label="ID">
                        </v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <v-text-field
                        v-model="item.name"
                        v-validate="'required|min:3'"
                        data-vv-name="name"
                        :error-messages="errors.collect('name')"
                        label="Name">
                        </v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <v-text-field
                        v-model="item.annotation_name"
                        v-validate="'required|min:3'"
                        data-vv-name="annotation_name"
                        :error-messages="errors.collect('annotation_name')"
                        label="Annotation Name">
                        </v-text-field>
                      </v-flex>
                    </v-layout>

                    <v-layout row>
                      <v-flex xs6>
                        <v-slider
                        v-model="item.threshold"
                        label="Threshold"
                        thumb-label="always"
                        >
                        </v-slider>
                      </v-flex>
                      <v-flex xs6>
                        <v-checkbox
                        v-model="item.stemming"
                        label="Stemming"
                        color="primary">
                        </v-checkbox>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6>
                        <v-combobox
                        v-model="item.positiveSeedwords"
                        multiple
                        chips
                        :search-input.sync="searchPos"
                        label="Positive Keywords (Semantic Matching)">
                          <template slot="no-data">
                            <v-list-tile v-if="searchPos">
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  Add {{ searchPos }}
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </template>
                          <template slot="selection" slot-scope="data">
                            <v-chip
                              color="positive"
                              small
                              class="v-chip--select-multi white--text"
                            >
                              <span>{{ data.item }}</span>
                            </v-chip>
                          </template>
                        </v-combobox>
                      </v-flex>
                      <v-flex xs6>
                        <v-combobox
                        v-model="item.negativeSeedwords"
                        multiple
                        chips
                        :search-input.sync="searchNeg"
                        label="Negative Keywords (Semantic Matching)">
                          <template slot="no-data">
                            <v-list-tile v-if="searchNeg">
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  Add {{ searchNeg }}
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </template>
                          <template slot="selection" slot-scope="data">
                            <v-chip
                              color="negative"
                              small
                              class="v-chip--select-multi white--text"
                            >
                              <span>{{ data.item }}</span>
                            </v-chip>
                          </template>
                        </v-combobox>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6>
                        <v-combobox
                        v-model="item.positiveInstances"
                        multiple
                        chips
                        :search-input.sync="searchPosIns"
                        label="Positive Keywords (Exact Matching)">
                          <template slot="no-data">
                            <v-list-tile v-if="searchPosIns">
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  Add {{ searchPosIns }}
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </template>
                          <template slot="selection" slot-scope="data">
                            <v-chip
                              color="positive"
                              small
                              class="v-chip--select-multi white--text"
                            >
                              <span>{{ data.item }}</span>
                            </v-chip>
                          </template>
                        </v-combobox>
                      </v-flex>
                      <v-flex xs6>
                        <v-combobox
                        v-model="item.negativeInstances"
                        multiple
                        chips
                        :search-input.sync="searchNegIns"
                        label="Negative Keywords (Exact Matching)">
                          <template slot="no-data">
                            <v-list-tile v-if="searchNegIns">
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  Add {{ searchNegIns }}
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </template>
                          <template slot="selection" slot-scope="data">
                            <v-chip
                              color="negative"
                              small
                              class="v-chip--select-multi white--text"
                            >
                              <span>{{ data.item }}</span>
                            </v-chip>
                          </template>
                        </v-combobox>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <!-- <v-flex xs6>
                        <v-select
                        label="Modeling Method"
                        :items="topicModelTypeCollection"
                        item-text="name"
                        item-value="id"
                        v-validate="'required'"
                        data-vv-name="topic model type"
                        :error-messages="errors.collect('topic model type')"
                        v-model="item.topicModelType">
                        </v-select>
                      </v-flex>
 -->
                      <v-flex xs3>
                        <label> Seedword Performance </label>
                        <h2> {{ item.seedwordFScore | formatPercentage }} </h2>
                      </v-flex>
                      <v-flex xs3>
                        <label> Supervised Performance </label>
                        <h2> {{ item.fScore | formatPercentage }} </h2>
                      </v-flex>
                    </v-layout>
                  </form>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions style="background: hsl(0, 0%, 97%)" class="pa-3">
            <v-btn color="primary" class="white--text" depressed @click.native="testTopic" :loading="topicTest.loading" :disabled="topicTest.loading">Show Seedword Based Results</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="grey darken-1" flat depressed @click.native="cancel()" :disabled="saveLoading">Cancel</v-btn>
            <v-btn color="accent" class="white--text" depressed @click.native="validateBeforeSubmit(save)" :loading="saveLoading" :disabled="saveLoading">Save</v-btn>
          </v-card-actions>
          <div v-if="topicTest.testSent">
            <v-divider></v-divider>
            <v-flex xs12>
              <v-tabs
              grow
              color="transparent"
              slider-color="primary"
              v-model="topicTest.tabIndex"
              >
                <v-tab ripple>
                  Ngrams
                </v-tab>
                <v-tab ripple>
                  Histogram
                </v-tab>
                <v-tab ripple>
                  Tagging Results
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="topicTest.tabIndex">
                <v-tab-item>
                  <v-card>
                    <v-container v-bind="{ [`grid-list-sm`]: true }" fluid>
                      <v-layout row wrap>
                        <v-flex
                          v-for="(ngram, i) in topicTest.results.ngrams"
                          :key="i"
                          xs4 sm2
                        >
                          <v-card tile class="elevation-1">
                            <v-card-text>
                              <h4> {{ ngram.phrase }} ({{ngram.frequency}}) </h4>
                            </v-card-text>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <v-container v-bind="{ [`grid-list-sm`]: true }" fluid>
                    <v-layout row wrap align-center
                      v-for="(h, i) in topicTest.results.histogram"
                      :key="i"
                    >
                      <v-flex xs1 class="text-xs-center">
                        {{h.interval}}
                      </v-flex>
                      <v-flex xs10>
                        <v-tooltip bottom>
                          <v-progress-linear
                          slot="activator"
                          color="primary"
                          height="20"
                          :value="parseInt(h.ratio)">
                          </v-progress-linear>
                          <span> {{h.ratio}}% </span>
                        </v-tooltip>
                      </v-flex>
                      <v-flex xs1 class="text-xs-center">
                        Frequency: {{h.frequence}}
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-tab-item>
                <v-tab-item>
                  <v-container>
                    <v-data-table
                      :headers="topicTest.taggingResultsTableHeaders"
                      :items="topicTest.results.taggingResults"
                      :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]">

                      <template slot="items" slot-scope="props">
                        <td>
                          <span v-for="(token, i) in props.item.tokens" :key="i">
                            <template v-if="token.color">
                              <v-tooltip
                                top
                                >
                                <v-chip
                                  slot="activator"
                                  dark
                                  text-color="white"
                                  class="v-chip--select-multi"
                                  :color="token.score >= 0.9 ? 'positive' : token.score >= 0.8 ? 'danger' : token.score >= 0.7 ? 'neutral' : 'negative'"
                                  small
                                >
                                  {{ token.token }}
                                </v-chip>
                                <span> <b>Score:</b> {{token.score}} </span>
                              </v-tooltip>
                            </template>
                            <template v-else>
                              {{ token.token }}
                            </template>
                          </span>
                        </td>
                        <td>{{ props.item.score }}</td>
                      </template>
                    </v-data-table>
                  </v-container>
                </v-tab-item>
              </v-tabs-items>
            </v-flex>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  props: {
    topicModel: {
      type: String,
      required: true,
      default: ''
    },
    topicId: {
      type: String,
      required: false,
      default: ''
    }
  },
  created () {
    if (!this.isNew) {
      this.setLoader({
        loading: true
      })
      this.fetchTopicItem()
    }
  },
  data () {
    return {
      item: {
        id: '',
        topicModel: '',
        name: '',
        annotation_name: '',
        positiveSeedwords: [],
        negativeSeedwords: [],
        positiveInstances: [],
        negativeInstances: [],
        isActive: false,
        threshold: 100.0,
        precision: 0.0,
        recall: 0.0,
        fScore: 0.0,
        stemming: true,
        modelPath: ''
      },
      topicTest: {
        results: {
          taggingResults: [],
          ngrams: [],
          histogram: []
        },
        taggingResultsTableHeaders: [
          {text: 'Text', sortable: false, value: 'html_text'},
          {text: 'Score', sortable: true, value: 'score'}
        ],
        loading: false,
        tabIndex: 0,
        testSent: false
      },
      searchPos: null,
      searchNeg: null,
      searchPosIns: null,
      searchNegIns: null,
      saveLoading: false,
      topicTestTabIndex: 0
    }
  },
  computed: {
    isNew () {
      return this.topicId == null || this.topicId === ''
    },
    ...mapState({
      topicModelTypeCollection: state => state.configurations.topicModelTypes
    })
  },
  methods: {
    cancel () {
      this.$router.push({name: 'topicModelEdit', params: { id: this.topicModel, stepProp: 1 }})
    },
    fetchTopicItem () {
      this.axios.get(`/topic-models/${this.topicModel}/topics/${this.topicId}`)
        .then(response => {
          this.setTopicItem(response.data)
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.setLoader({
            loading: false
          })
        })
    },
    setTopicItem (topic) {
      this.item.id = topic.id
      this.item.name = topic.name
      this.item.annotation_name = topic.annotation_name
      this.item.positiveSeedwords = topic.positive_seedwords
      this.item.negativeSeedwords = topic.negative_seedwords
      this.item.positiveInstances = topic.positive_instances
      this.item.negativeInstances = topic.negative_instances
      this.item.isActive = topic.is_active
      this.item.threshold = topic.threshold * 100
      this.item.precision = topic.precision
      this.item.recall = topic.recall
      this.item.fScore = topic.f_score
      this.item.stemming = topic.stemming_choice
      this.item.modelPath = topic.model_path
      this.item.topicModel = this.topicModel
      this.item.topicModelType = topic.use_supervised_topic_model ? 1 : 0
      this.item.seedwordFScore = topic.seed_word_f_score
    },
    testTopic () {
      this.topicTest.loading = true
      this.topicTest.testSent = false
      const topicToTest = {
        id: this.item.id,
        name: this.item.name,
        annotation_name: this.item.annotation_name,
        positive_seedwords: this.item.positiveSeedwords,
        negative_seedwords: this.item.negativeSeedwords,
        positive_instances: this.item.positiveInstances,
        negative_instances: this.item.negativeInstances,
        is_active: this.item.isActive,
        threshold: this.item.threshold / 100.0,
        precision: this.item.precision,
        recall: this.item.recall,
        f_score: this.item.fScore,
        stemming_choice: this.item.stemming,
        model_path: this.item.modelPath
      }
      if (this.isNew) {
        this.axios.post(`/topic-models/${this.topicModel}/topics/try`, topicToTest)
          .then(response => {
            this.topicTest.loading = true
            const data = response.data
            this.topicTest.results.ngrams = data.ngrams
            this.topicTest.results.histogram = data.histogram
            this.topicTest.results.taggingResults = data.tagging_results

            for (let i = 0; i < this.topicTest.results.taggingResults.length; i++) {
              const taggingResult = this.topicTest.results.taggingResults[i]
              let htmlText = ''
              for (let j = 0; j < taggingResult.tokens.length; j++) {
                const token = taggingResult.tokens[j]
                htmlText += token.score > 0 ? `<v-chip color="${token.color}"><v-avatar>${token.score.toFixed(2)}</v-avatar>${token.token}</v-chip>` : token.token
                if (j < taggingResult.tokens.length - 1) {
                  htmlText += ' '
                }
              }
              this.topicTest.results.taggingResults[i].htmlText = htmlText
            }
            this.topicTest.testSent = true
          })
          .catch(error => {
            this.handleAxiosError(error)
          })
          .finally(() => {
            this.topicTest.loading = false
          })
      } else {
        this.axios.post(`/topic-models/${this.topicModel}/topics/${this.item.id}/try`, topicToTest)
          .then(response => {
            this.topicTest.loading = true
            const data = response.data
            this.topicTest.results.ngrams = data.ngrams
            this.topicTest.results.histogram = data.histogram
            this.topicTest.results.taggingResults = data.tagging_results

            for (let i = 0; i < this.topicTest.results.taggingResults.length; i++) {
              const taggingResult = this.topicTest.results.taggingResults[i]
              let htmlText = ''
              for (let j = 0; j < taggingResult.tokens.length; j++) {
                const token = taggingResult.tokens[j]
                htmlText += token.score > 0 ? `<v-chip color="${token.color}"><v-avatar>${token.score.toFixed(2)}</v-avatar>${token.token}</v-chip>` : token.token
                if (j < taggingResult.tokens.length - 1) {
                  htmlText += ' '
                }
              }
              this.topicTest.results.taggingResults[i].htmlText = htmlText
            }
            this.topicTest.testSent = true
          })
          .catch(error => {
            this.handleAxiosError(error)
          })
          .finally(() => {
            this.topicTest.loading = false
          })
      }
    },
    save () {
      this.saveLoading = true
      let itemToSave = {
        name: this.item.name,
        annotation_name: this.item.annotation_name,
        positive_seedwords: this.item.positiveSeedwords,
        negative_seedwords: this.item.negativeSeedwords,
        positive_instances: this.item.positiveInstances,
        negative_instances: this.item.negativeInstances,
        is_active: this.item.isActive,
        threshold: this.item.threshold / 100.0,
        precision: this.item.precision,
        recall: this.item.recall,
        f_score: this.item.fScore,
        stemming_choice: this.item.stemming,
        model_path: this.item.modelPath
      }
      if (this.isNew) {
        this.axios.post(`/topic-models/${this.topicModel}/topics/`, itemToSave)
          .then(response => {
            this.$router.push({name: 'topicModelEdit', params: { id: this.topicModel, stepProp: 1 }})
          })
          .catch(error => {
            this.handleAxiosError(error)
          })
          .finally(() => {
            this.saveLoading = false
          })
      } else {
        itemToSave.id = this.item.id
        this.axios.put(`/topic-models/${this.topicModel}/topics/${this.item.id}`, itemToSave)
          .then(response => {
            this.$router.push({name: 'topicModelEdit', params: { id: this.topicModel, stepProp: 1 }})
          })
          .catch(error => {
            this.handleAxiosError(error)
          })
          .finally(() => {
            this.saveLoading = false
          })
      }
    },
    ...mapActions({
      setLoader: 'loader/setLoader'
    })
  }
}
</script>

<style>

</style>
